<template>
  <!-- 바깥(어두운 영역)을 누르면 close (취소 버튼이 화면 이동인 경우와 구분) -->
  <div class="mall-confirm-popup" @click.self="$emit('close')">
    <div class="mall-confirm-popup__box">
      <div class="mall-confirm-popup__contents">
        <slot name="icon">
          <img class="mall-confirm-popup__icon" :src="icon" alt="" />
        </slot>
        <div class="mall-confirm-popup__text">
          <span class="typo-lg-semi mall-confirm-popup__title">{{ title }}</span>
          <span class="mall-confirm-popup__message">
            <span v-for="line in messageLines" :key="line" class="mall-confirm-popup__line">{{ line }}</span>
          </span>
        </div>
      </div>
      <div class="mall-confirm-popup__buttons">
        <MallButton :label="cancelLabel" :type="'secondary'" @click="$emit('cancel')" />
        <MallButton :label="confirmLabel" :type="'primary'" @click="$emit('confirm')" />
      </div>
    </div>
  </div>
</template>

<script>
import MallButton from '@/components/new/atoms/MallButton.vue'

export default {
  name: 'MallConfirmPopup',
  components: {
    MallButton,
  },
  props: {
    // icon 슬롯을 넘기면 대신 사용
    icon: {
      type: String,
      default: '',
    },
    // 줄바꿈(\n) 그대로 노출
    title: {
      type: String,
      required: true,
    },
    // 줄 단위 안내 문구
    messageLines: {
      type: Array,
      default: () => [],
    },
    cancelLabel: {
      type: String,
      default: '취소',
    },
    confirmLabel: {
      type: String,
      default: '확인',
    },
  },
}
</script>

<style scoped>
.mall-confirm-popup {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(24, 24, 28, 0.8);
  /* 바텀시트(1000~1001) 위에 노출 */
  z-index: 1100;
}

.mall-confirm-popup__box {
  display: flex;
  width: 320px;
  padding: 20px 16px 16px 16px;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  border-radius: 20px;
  background: #FFF;
  box-sizing: border-box;
}

.mall-confirm-popup__contents {
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.mall-confirm-popup__icon {
  display: block;
  width: 80px;
  height: 80px;
}

.mall-confirm-popup__text {
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 4px;
  text-align: center;
}

.mall-confirm-popup__title {
  white-space: pre-line;
}

.mall-confirm-popup__message {
  color: #4E5968;
  font-family: Pretendard;
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-medium);
  line-height: var(--line-height-normal);
}

.mall-confirm-popup__line {
  display: block;
}

.mall-confirm-popup__buttons {
  display: flex;
  width: 100%;
  align-items: flex-end;
  gap: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/new/molecules/MallConfirmPopup.vue